import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { TViewMode } from '@/typings'

type Theme = 'light' | 'dark' | 'system'

interface SettingStoreState {
  theme: Theme
  viewMode: TViewMode
  date: string
  selectedLibraryId: string
  selectedLibraryShardId: string
  isSaleBanner: boolean
}

interface SettingStoreActions {
  changeTheme: (t: string) => void
  changeView: () => void
  changeDate: (value: string) => void
  mode: () => 'light' | 'dark'
  setSelectedLibraryId: (id: string) => void
  setSelectedLibraryShardId: (shardId: string) => void
  setIsSaleBanner: (isShow: boolean) => void
}

type SettingStore = SettingStoreState & SettingStoreActions

export const useSetting = create<SettingStore>()(
  persist(
    (set, get) => ({
      theme: 'light',
      viewMode: TViewMode.GRID,
      date: 'MM/dd/yyyy',
      selectedLibraryId: '',
      selectedLibraryShardId: '',
      isSaleBanner: true,
      changeTheme: (value) =>
        set(() => {
          const theme = value as Theme
          return { theme }
        }),
      changeView: () =>
        set(() => {
          const isList = get().viewMode === TViewMode.LIST
          const viewMode = isList ? TViewMode.GRID : TViewMode.LIST
          return { viewMode }
        }),
      changeDate: (value: string) => {
        set(() => {
          const date = value
          return { date }
        })
      },
      mode: () => {
        const currentTheme = get().theme
        const isDark =
          currentTheme === 'dark' ||
          (currentTheme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
        return isDark ? 'dark' : 'light'
      },
      setSelectedLibraryId: (id: string) => set(() => ({ selectedLibraryId: id })),
      setSelectedLibraryShardId: (shardId: string) => set(() => ({ selectedLibraryShardId: shardId })),
      setIsSaleBanner: (isShow: boolean) => set(() => ({ isSaleBanner: isShow })),
    }),
    {
      name: 'setting-storage',
    },
  ),
)
